import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import IS_BROWSER from '@picsart/rc/isBrowser';
import { post, getApiUrl, get, httpDelete } from '../httpService/index.js';
import { L as Logger } from '../logger-4df3b60c.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initiateCardUpdate = function initiateCardUpdate(_ref) {
  var userId = _ref.userId,
    accessToken = _ref.accessToken,
    state = _ref.state,
    redirectUrl = _ref.redirectUrl,
    original_order_id = _ref.original_order_id;
  Logger.deprecate('`adyenService => updateCard` should be used instead.');
  return post("".concat(getApiUrl(), "/shop/subscription/users/cards"), _objectSpread(_objectSpread({}, state.data), {}, {
    userId: userId,
    redirectUrl: redirectUrl,
    original_order_id: original_order_id
  }), {
    headers: authorizationHeader(accessToken)
  });
};
var fetchSavedPayment = function fetchSavedPayment(accessToken) {
  return get("".concat(getApiUrl(), "/shop/subscription/users/cards"), {
    headers: authorizationHeader(accessToken)
  });
};
var deleteCard = function deleteCard(accessToken) {
  return httpDelete("".concat(getApiUrl(), "/shop/subscription/users/cards"), {
    headers: authorizationHeader(accessToken)
  });
};
var fetchSavedCards = function fetchSavedCards(accessToken) {
  return get("".concat(getApiUrl(), "/shop/subscription/adyen/users/cards"), {
    headers: authorizationHeader(accessToken)
  });
};
var storePaymentInfo = function storePaymentInfo(paymentInfo) {
  sessionStorage.setItem('paymentAction', 'redirect');
  sessionStorage.setItem('paymentInfo', JSON.stringify(paymentInfo));
};
var getStoredPaymentInfo = function getStoredPaymentInfo() {
  if (!IS_BROWSER) {
    return;
  }
  try {
    var paymentInfoStr = sessionStorage.getItem('paymentInfo');
    if (paymentInfoStr) {
      return JSON.parse(paymentInfoStr);
    }
  } catch (error) {
    Logger.error(error);
  }
};
var checkRedirectAction = function checkRedirectAction() {
  return IS_BROWSER && sessionStorage.getItem('paymentAction') === 'redirect';
};
var clearPaymentInfo = function clearPaymentInfo() {
  sessionStorage.removeItem('paymentAction');
  sessionStorage.removeItem('paymentInfo');
};
var paymentsService = {
  getStoredPaymentInfo: getStoredPaymentInfo,
  checkRedirectAction: checkRedirectAction,
  initiateCardUpdate: initiateCardUpdate,
  fetchSavedPayment: fetchSavedPayment,
  storePaymentInfo: storePaymentInfo,
  clearPaymentInfo: clearPaymentInfo,
  fetchSavedCards: fetchSavedCards
};

export { checkRedirectAction, clearPaymentInfo, paymentsService as default, deleteCard, fetchSavedCards, fetchSavedPayment, getStoredPaymentInfo, initiateCardUpdate, storePaymentInfo };
//# sourceMappingURL=index.js.map
